<template>
  <div class="actions">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: [
  ],
}
</script>


<style scoped>
.actions {
  background-color: #f9f9f9;
  /*bottom: calc(0.5rem + env(safe-area-inset-bottom));*/
  bottom: env(safe-area-inset-bottom);
  /*border-radius: 16px;*/
  border-radius: 16px 16px 0 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
  height: 306px;
  /*left: 0.5rem;*/
  left: 0;
  position: fixed;
  transition: 0.5s all ease;
  /*width: calc(100% - 1rem);*/
  width: 100%;
  z-index: 1210;
}
.actions.panel {
  border-radius: 16px 16px 0 0;
  bottom: 0;
  height: calc(100% - 1rem - env(safe-area-inset-top));
  left: 0;
  width: 100%;
}
</style>
